// extracted by mini-css-extract-plugin
export default {"backBtn":"BackButton_backBtn__0ojFu"};